import * as qs from 'query-string';

export const getParsedQueryString = location => qs.parse(location.search);
